<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Therapists and Life Coaches</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Expand your reach and attract new clients as a therapist or life coach with LocalScale, your trusted ally in targeted advertising for personal development</p>
                        <p>In the field of therapy and coaching, establishing trust and connection with clients is essential for fostering growth and transformation.</p>
                        <p>With LocalScale, you can enhance your visibility and connect with individuals seeking support and guidance in their personal journey.</p>
                        <p>Whether you specialize in counseling, therapy, coaching, or holistic wellness, our precision-targeted ad network allows you to reach potential clients in your local community who are actively seeking your services.</p>
                        <p>By leveraging LocalScale, you can ensure that your practice stands out and resonates with those in need of support, ultimately helping more individuals achieve their goals and live fulfilling lives.</p>
                        <p>Let us help you expand your practice and make a meaningful impact on the lives of others.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-therapy-and-life-coaching.png" alt="Therapy And Life Coaching">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been a game-changer for my therapy practice. Their targeted advertising solutions have allowed me to reach individuals who are seeking support and guidance in their personal growth journey. Thanks to LocalScale, I've been able to connect with more clients and help them navigate life's challenges with confidence and clarity.”</h3>
                    <p class="testimonial-customer">– Dr. Samantha Richards, Licensed Therapist and Life Coach</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
